import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import { loadStripe, Stripe } from '@stripe/stripe-js';

@Injectable({
  providedIn: 'root'
})
export class StripeProviderServiceService {

  constructor() { }

  public loadStripe(): Promise<Stripe | null> {
    return loadStripe(environment.stripeKey);
  }
}
